import styled from "styled-components";
import { BRAND, TEXT_SECONDARY, WHITE } from "@streeteasy/design-system/colors";
import {
  Caps,
  SecondaryLarge,
  SecondarySmall
} from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const CardContainer = styled.div`
  align-items: flex-end;
  background: ${WHITE};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  min-height: 125px;
  position: relative;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: initial;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 18px;
  }
`;

export const AreaInfo = styled(Caps)`
  color: ${TEXT_SECONDARY};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Title = styled(SecondarySmall).attrs({ as: "p" })`
  color: ${BRAND};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Price = styled(SecondaryLarge).attrs({ as: "p" })`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;

  @media screen and (max-width: ${smallScreen}px) {
    font-size: 18px;
  }
`;

export const InfoBox = styled.div`
  margin-left: auto;
  min-width: 0;
  padding: 15px 15px 10px 17px;
  width: 60%;
`;

export const LinkToProperty = styled.a`
  display: block;
  font-size: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
`;

export const BottomBox = styled.div`
  margin-left: auto;
  width: 60%;

  @media screen and (max-width: ${smallScreen}px) {
    width: 100%;
  }
`;
